import TokenServer from './src/token-server'

const Token = new TokenServer()
Token.install = function (Vue) {
  Vue.observable(Token)
}

async function getToken() {
  return Token.getToken();
}

export default Token
export { getToken };
